export default {
    data() {
        return {
            stepList: [
                {index: '1', name: '選擇服務計劃'},
                {index: '2', name: '輸入資料'},
                {index: '3', name: '資料確認'},
                {index: '4', name: '付款'}
            ]
        }
    }
}